import { createAction, props } from '@ngrx/store'
import { CustomerInformationState } from './user-profile.state'
import { C4PaymentMethodDetail, C4PaymentMethodsRequest } from '@api/http.service'

export enum CustomerInfoTypes {
  CUSTOMER_INFO_LOAD = '[CUSTOMER_INFO] Load Customer Info',
  CUSTOMER_INFO_SUCCESS = '[CUSTOMER_INFO] Customer Info Successfully Loaded',
  CUSTOMER_INFO_FAIL = '[CUSTOMER_INFO] Loading Customer Info failed',
  C4_LOGIN_LOAD = '[CUSTOMER_INFO] Login to C4 API',
  C4_LOGIN_SUCCESS = '[CUSTOMER_INFO] Login to C4 API succeeded',
  C4_LOGIN_FAIL = '[CUSTOMER_INFO] Login to C4 API failed',
  PAYMENT_METHODS_LOAD = '[PAYMENT_METHODS] Load Payment Methods',
  PAYMENT_METHODS_SUCCESS = '[PAYMENT_METHODS] Payment Methods Successfully Loaded',
  PAYMENT_METHODS_FAIL = '[PAYMENT_METHODS] Loading Payment Methods failed',
}

export const CustomerInfoActions = {
  customerInfoLoad: createAction(CustomerInfoTypes.CUSTOMER_INFO_LOAD, props<{ payload: string }>()), //payload = email address
  customerInfoSuccess: createAction(
    CustomerInfoTypes.CUSTOMER_INFO_SUCCESS,
    props<{ payload: CustomerInformationState }>(),
  ),
  customerInfoFail: createAction(CustomerInfoTypes.CUSTOMER_INFO_FAIL),
  c4LoginLoad: createAction(CustomerInfoTypes.C4_LOGIN_LOAD, props<{ payload: C4LoginParams }>()),
  c4LoginSuccess: createAction(CustomerInfoTypes.C4_LOGIN_SUCCESS, props<{ payload: C4LoginSuccessParams }>()),
  c4LoginFail: createAction(CustomerInfoTypes.C4_LOGIN_FAIL),
  paymentMethodsLoad: createAction(
    CustomerInfoTypes.PAYMENT_METHODS_LOAD,
    props<{ payload: C4PaymentMethodsRequest }>(),
  ),
  paymentMethodsSuccess: createAction(
    CustomerInfoTypes.PAYMENT_METHODS_SUCCESS,
    props<{ payload: C4PaymentMethodDetail[] }>(),
  ),
  paymentMethodsFail: createAction(CustomerInfoTypes.PAYMENT_METHODS_FAIL),
}

export interface C4LoginParams {
  // uuid: string
  // adrNr: string | undefined
  uuidAuthent: string | undefined
}

export interface C4LoginSuccessParams {
  sessionId: string
  uuid: string // not needed, read from KC token instead
  adrGr: string // not needed currenty, defined in config server instead
  isUserGroupAdmin?: boolean
}
